module.exports = __webpack_public_path__ + "static/media/29FUNOV1.620ce7a1.jpg";